<template>
  <div>
    <!-- 
      @name contextMenu
      @desc 右键菜单
      @param contextMenu table 选中行
    -->
    <contextMenu ref="contextMenu" :contextMenu="contextmenuRow" :isTask="false"></contextMenu>

    <div class="relation-div" v-show="jobRelations.length > 0">
      <span class="columnName">关联计划：</span>
      <el-tag
        v-for="(item, index) in jobRelations"
        type="info"
        effect="plain"
        class="relation-tag"
        :key="index"
      >
        <el-link
          @click.native="showJobDetail(item.RELATIONID)"
          icon="el-icon-document"
          type="info"
          style="font-size:14px"
          :underline="false"
        >{{ item.RELATIONNAME }}</el-link>
      </el-tag>
    </div>
    <div class="relation-div" v-show="taskRelations.length > 0">
      <span class="columnName">关联任务：</span>
      <div
        @contextmenu.prevent="liContextmenu(item,$event)"
        style="dispaly:inline-blcok;"
        v-for="(item, index) in taskRelations"
        :key="index"
      >
        <el-tag
          effect="plain"
          type="info"
          :style="item.RELATIONSTATE | stateBackgrondColorFormat"
          class="relation-tag"
          @close="delRelation(item)"
          :closable="closable"
        >
          <el-link
            @click.native="showTaskDetail(item.RELATIONID)"
            icon="el-icon-document"
            type="info"
            :style="item.RELATIONSTATE | stateColorFormat"
            :underline="false"
          >{{ item.RELATIONNAME }}({{ item.RELATIONUSERNAME }})</el-link>
        </el-tag>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DelRecordRelation,
  getTaskByTaskId,
} from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  props: {
    relations: {
      type: Array,
      default: () => [],
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    contextMenu: () => import("@/views/task/common/contextmenu.vue"), //右键菜单
  },
  data() {
    return {
      contextmenuRow: {},
    };
  },
  filters: {
    stateBackgrondColorFormat: function (value) {
      var val = "#ffe6e6";
      switch (value) {
        case 1:
          val = "#e5f4e3";
          break;
        case 2:
          val = "#e2ecfb";
          break;
        case 3:
          val = "#eaecef";
          break;
      }
      return {
        "background-color": val,
      };
    },
    stateColorFormat: function (value) {
      var val = "#ff7777";
      switch (value) {
        case 1:
          val = "#70c063";
          break;
        case 2:
          val = "#6194e7";
          break;
        case 3:
          val = "#d6d7e8";
          break;
      }
      return {
        color: val,
        "font-size": "14px",
      };
    },
  },
  computed: {
    jobRelations() {
      return this.relations != null
        ? this.relations.filter((o) => o.RELATIONTYPE == 1)
        : [];
    },
    taskRelations() {
      return this.relations != null
        ? this.relations.filter((o) => o.RELATIONTYPE == 0)
        : [];
    },
  },
  methods: {
    showJobDetail(id) {
      let routeUrl = `${location.href.substr(
        0,
        location.href.lastIndexOf("/")
      )}/palnDetails?id=${id}`;
      console.log(routeUrl);
      window.open(routeUrl, "_blank");
    },
    showTaskDetail(taskid) {
      let routeUrl = `${location.href.substr(
        0,
        location.href.lastIndexOf("/")
      )}/task-detailspage?taskid=${taskid}`;
      console.log(routeUrl);
      window.open(routeUrl, "_blank");
    },
    delRelation(val) {
      DelRecordRelation(val.ID).then((result) => {
        if (result.ResultCode > 0) {
          this.$emit("delRelation", val);
        } else {
          this.$message.error(result.MsgInfo);
        }
      });
    },

    /**
     * @method table右键点击显示菜单
     * @param {Object} [ row ] table右键点击行
     * @param {Object} [ column ] table右键点击列
     * @param {Object} [ event ] column ] 事件源
     */
    liContextmenu(row, event) {
      console.log(row);
      event.preventDefault();
      getTaskByTaskId(row.RELATIONID, cookieUser.userId).then((res) => {
        const postition = {
          top: event.clientY,
          left: event.clientX,
        };
        this.contextmenuRow = res;
        this.$refs.contextMenu.Show(postition);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.relation-tag {
  margin-top: 5px;
  height: 26px !important;
  line-height: 20px !important;
  padding: 0 4px !important;
  cursor: pointer;
}
.relation-div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  //margin-bottom: 5px;
}

.relation-div > * {
  margin-right: 10px;
}
.columnName {
  color: #999999;
  margin-right: 2px;
  font-size: 12px;
}
</style>
